import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import '../../assets/stylesheets/Union/Main.scss';
import Header from "../Club/components/Header";
import OptionRow from "../Profile/OptionRow";
import unionSettings from '../../config/union';
import {getCurrentClubId, getUnion, getClubUnion, getAccountAvatars} from "../../store/selectors";
import { unionMembersRequest, unionPendingsRequest } from '../../store/actionCreators/union';

const UnionMain =() => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const unionId = useParams().id;
    const clubId = useSelector(getCurrentClubId);
    const unionData = useSelector(getClubUnion);
    const avatarList = useSelector(getAccountAvatars);
    const currentUnionAvatar = avatarList[unionId] ? (avatarList[unionId].imageUrl ? avatarList[unionId] : {}) : {};

    const menu = unionSettings.menu [!!unionData ? 'owner' : 'member' ];
    const [rowParams, setRowParams] = useState({
        disband: { unionId },
        quit: { unionId }
    });

    console.log(unionData, 'Union Data');

    useEffect(() => {
        if( unionId ) {
            dispatch(unionMembersRequest(unionId));
            dispatch(unionPendingsRequest(unionId));
        }
    }, [unionId]);

    return (
        <div className={`unionMenu`}>
            <Header title={'union'} to={`/club/${clubId}`}/>
            <div className={"currentUnionAvatar"}>
                <Link to={`/union/${unionId}/edit`}>
                    <div id={"uploadAvatar"}></div>
                    {currentUnionAvatar.imageUrl ? (<div className={'uploadAvatarPreview'} style={{backgroundImage: 'url(' + currentUnionAvatar.imageUrl + ')'}}></div>) : ''}
                    {!!unionData && <span className="editPencil"></span>}
                </Link>
            </div>
            <div className = {`unionInfo`}>
                <span>{unionData.username || ''}</span>
                <p>{t('unionId')}: {unionId}</p>
            </div>
            <div className={`menuContainer`}>
                { menu.map((item, index)=>
                    <OptionRow to={`/union/${unionId}/${item}`} key={index} option={item} section={'union'} params={rowParams[item] || ''} />
                )}
            </div>
        </div>
    );
};

export default UnionMain ;
